import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IVisuallyHiddenConfiguration, IVisuallyHiddenProps, IVisuallyHiddenState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { VISUALLYHIDDEN_CATEGORY_KEY, VISUALLYHIDDEN_COMPONENT_KEY } from './VisuallyHidden.meta.js';

export class VisuallyHidden extends ComponentBase<
	IVisuallyHiddenProps,
	IVisuallyHiddenState,
	IVisuallyHiddenConfiguration
> {
	categoryKey = VISUALLYHIDDEN_CATEGORY_KEY;
	componentKey = VISUALLYHIDDEN_COMPONENT_KEY;

	constructor(props: IVisuallyHiddenProps) {
		super(props);
	}

	render() {
		const { className, children } = this.props;
		return (
			<Wrapper
				className={className}
				style={{
					position: 'absolute',
					left: '-10000px',
					top: 'auto',
					width: '1px',
					height: '1px',
					overflow: 'hidden',
				}}
			>
				{children}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(
	observer(VisuallyHidden),
	VISUALLYHIDDEN_CATEGORY_KEY,
	VISUALLYHIDDEN_COMPONENT_KEY,
);
